//
import * as Type from '@/store/Type/index';

//
export default {
  nameCollection: Type.NAME_COLLECTION_PROFILE_ADMIN,
  statusAside: false,
  // ----------------
  allCategory: [],
  allItems: [],
  // ----------------
  actionConfirmAlert: {
    statusConfirmAlert: false,
    messageConfirmAlert: null,
    titleBtnDelete: null
  },
  confirmedDeleted: false,
  // ----------------
  countIndex: 0
};
